import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
const Services = () => {
  return (
    <div>
      <Helmet>
        <title>
          Our Services | Orient Elevators Pvt. Ltd. | Elevator Installation &
          Maintenance
        </title>

        <meta
          name="keywords"
          content="Orient Elevators, elevator services, lift installation, elevator maintenance, commercial elevators, home lifts, passenger lifts, elevator modernization, elevator repair"
        />

        <meta
          name="description"
          content="Explore the comprehensive services offered by Orient Elevators Pvt. Ltd., including elevator installation, maintenance, repair, and modernization for residential and commercial buildings. Reliable and safe vertical transportation solutions."
        />
      </Helmet>

      <style>{`
        .service-item {
          border: 1px solid #008bd2;
          padding: 10px;
          border-radius: 5px;
        }
      `}</style>

      <section
        className="page-title centred"
        style={{
          backgroundImage: "url('assets/img/slider/slider-2.jpg')",
        }}
      >
        <div className="auto-container">
          <div className="content-box">
            <div className="title">
              <h1>Services</h1>
            </div>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/"> Home</Link>
              </li>
              <li>Services</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Services */}
      <div className="feature-area ft-bg1 py-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="site-heading text-center">
                {/* <span class="site-title-tagline">
                    <i class="far fa-lightbulb-on"></i> Our Feature
                  </span> */}
                <h2 className="site-title ">
                  OUR <span>SERVICES</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="feature-wrapper">
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <div
                  className="text-center service-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="service-img">
                    <img src="assets/img/project/1.jpg" alt="img" />
                    <div class="service-icon">
                      <i class="icon-electric"></i>
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Passenger Elevators</a>
                    </h3>
                    <p className="service-text">
                      Orient Elevators offers state-of-the-art Passenger
                      Elevators designed for comfort, safety, and efficiency.
                      Built with advanced technology and precision engineering
                    </p>

                    <ul className="btn-call">
                      <li>
                        <div className="btn-box">
                          <a href="tel:+919918001880" class="btn btn-primary">
                            {" "}
                            <i className="fa fa-phone"></i> Call Now
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="btn-box">
                          <a
                            href="https://wa.me/+919918001880"
                            className="btn btn-success thm-btn"
                          >
                            <i className="fa fa-whatsapp"></i> Whatsapp
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div
                  className="text-center service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-img">
                    <img src="assets/img/project/2.jpg" alt="img" />
                    <div className="service-icon">
                      <i className="icon-electric"></i>
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Hospital Elevators</a>
                    </h3>
                    <p className="service-text">
                      Orient Elevators provides specially designed Hospital
                      Elevators that ensure safe, smooth, and hygienic
                      transportation within healthcare environments.
                    </p>
                    <ul className="btn-call">
                      <li>
                        <div className="btn-box">
                          <a href="tel:+919918001880" class="btn btn-primary">
                            {" "}
                            <i className="fa fa-phone"></i> Call Now
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="btn-box">
                          <a
                            href="https://wa.me/+919918001880"
                            className="btn btn-success thm-btn"
                          >
                            <i className="fa fa-whatsapp"></i> Whatsapp
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div
                  className="text-center service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-img">
                    <img src="assets/img/project/3.jpg" alt="img" />
                    <div className="service-icon">
                      <i className="icon-electric"></i>
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Bungalow Elevators</a>
                    </h3>
                    <p className="service-text">
                      Orient Elevators offers elegant and efficient Bungalow
                      Elevators designed to enhance comfort, convenience, and
                      luxury in private residences.
                    </p>
                    <ul className="btn-call">
                      <li>
                        <div className="btn-box">
                          <a href="tel:+919918001880" class="btn btn-primary">
                            {" "}
                            <i className="fa fa-phone"></i> Call Now
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="btn-box">
                          <a
                            href="https://wa.me/+919918001880"
                            className="btn btn-success thm-btn"
                          >
                            <i className="fa fa-whatsapp"></i> Whatsapp
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div
                  className="text-center service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-img">
                    <img src="assets/img/project/4.jpg" alt="img" />
                    <div className="service-icon">
                      <i className="icon-electric"></i>
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Capsule Elevators</a>
                    </h3>
                    <p className="service-text">
                      Orient Elevators presents premium Capsule Elevators that
                      combine advanced engineering with stunning aesthetics,
                      creating a perfect blend of functionality.
                    </p>
                    <ul className="btn-call">
                      <li>
                        <div className="btn-box">
                          <a href="tel:+919918001880" class="btn btn-primary">
                            {" "}
                            <i className="fa fa-phone"></i> Call Now
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="btn-box">
                          <a
                            href="https://wa.me/+919918001880"
                            className="btn btn-success thm-btn"
                          >
                            <i className="fa fa-whatsapp"></i> Whatsapp
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div
                  className="text-center service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-img">
                    <img src="assets/img/project/5.jpg" alt="img" />
                    <div className="service-icon">
                      <i class="icon-electric"></i>
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 class="service-title">
                      <a href="#">Goods Elevators</a>
                    </h3>
                    <p className="service-text">
                      Orient Elevators offers robust and high-performance Goods
                      Elevators designed to handle heavy loads with safety,
                      strength, and efficiency.
                    </p>
                    <ul className="btn-call">
                      <li>
                        <div className="btn-box">
                          <a href="tel:+919918001880" class="btn btn-primary">
                            {" "}
                            <i className="fa fa-phone"></i> Call Now
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="btn-box">
                          <a
                            href="https://wa.me/+919918001880"
                            className="btn btn-success thm-btn"
                          >
                            <i className="fa fa-whatsapp"></i> Whatsapp
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div
                  className="text-center service-item wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="service-img">
                    <img src="assets/img/project/6.jpg" alt="img" />
                    <div className="service-icon">
                      <i className="icon-electric"></i>
                    </div>
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">
                      <a href="#">Service Elevators</a>
                    </h3>
                    <p className="service-text">
                      Orient Elevators provides reliable and efficient Service
                      Elevators specially designed for the smooth transportation
                      of goods, supplies, and staff in commercial
                    </p>
                    <ul className="btn-call">
                      <li>
                        <div className="btn-box">
                          <a href="tel:+919918001880" class="btn btn-primary">
                            {" "}
                            <i className="fa fa-phone"></i> Call Now
                          </a>
                        </div>
                      </li>
                      <li>
                        <div className="btn-box">
                          <a
                            href="https://wa.me/+919918001880"
                            className="btn btn-success thm-btn"
                          >
                            <i className="fa fa-whatsapp"></i> Whatsapp
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*End Services */}
    </div>
  );
};

export default Services;
